import { CalendarTimeRanges } from '../types/Calendar'

type ApplyDateRangeToCalendarTimeRangesOptions = {
  onlyIfInSyncWith?: { dateFrom?: number; dateTo?: number }
}

/**
 * Writes a picker date range onto every calendar viewport.
 *
 * When `onlyIfInSyncWith` is set (automatic DateRangePicker bounds clamp, GR-2985), calendars
 * whose visible window still matches the previous picker range are moved, so an initial history
 * load still shifts the default "last 14 days ending today" onto the last tracked window. Calendars
 * the user has already panned away from that picker range are left alone, so scrolling to a later
 * empty month (e.g. March 2026 after tracking ended on 12/29/2025) is not yanked back.
 */
export const applyDateRangeToCalendarTimeRanges = (
  currentRanges: CalendarTimeRanges,
  fromTime?: number,
  toTime?: number,
  options?: ApplyDateRangeToCalendarTimeRangesOptions
): CalendarTimeRanges => {
  const nextRanges = { ...currentRanges }

  Object.keys(nextRanges).forEach((calendarId) => {
    const currentRange = nextRanges[calendarId]
    if (
      options?.onlyIfInSyncWith &&
      (currentRange.timeStart !== options.onlyIfInSyncWith.dateFrom || currentRange.timeEnd !== options.onlyIfInSyncWith.dateTo)
    ) {
      return
    }

    nextRanges[calendarId] = { timeStart: fromTime, timeEnd: toTime }
  })

  return nextRanges
}
